/**
 * Created by Vladislav on 08.09.2024.
 */

const PlatformStorage = function () {
    this.isReady = false;
    this.isLoading = false;
    this.data = undefined;

    this.bus = new ConnectorEventEmitter();
};

PlatformStorage.prototype.start = function () {
    if (this.isSupported()) {
        this.initializeInterval = setInterval(this.initialize.bind(this), 5000);

        connector.platform.whenConnected(this.initialize.bind(this));
    }
};

PlatformStorage.prototype.whenReady = function (callback) {
    if (this.isReady) {
        callback();
    } else {
        this.bus.once("ready", callback);
    }
};

PlatformStorage.prototype.isSupported = function () {
    if (connector.platform.oneOf(connector.MSSTART)) {
        return !connector.info.isMobile;
    }

    return connector.platform.oneOf(connector.SAMSUNG, connector.YANDEX, connector.VK, connector.OK, connector.INSTANT, connector.TEST);
};

PlatformStorage.prototype.initialize = function () {
    if (this.isReady || this.isLoading || !connector.platform.isConnected()) {
        return;
    }

    const loginRequired = connector.platform.oneOf(connector.SAMSUNG);
    if (loginRequired && !(connector.social.isConnected() && connector.social.isLoggedIn())) {
        return;
    }

    this.load().then((ready) => {
        this.isReady = ready;

        if (ready) {
            clearInterval(this.initializeInterval);

            this.bus.trigger("ready");
        }
    });
};

PlatformStorage.prototype.load = function () {
    if (this.isLoading) {
        return this.loadingPromise;
    }

    this.isLoading = true;

    if (!connector.platform.isConnected()) {
        this.isLoading = false;
        this.bus.trigger("error:load", ERRORS.NOT_CONNECTED);
        return Promise.resolve(false);
    }

    this.loadingPromise = new Promise((resolve) => {
        connector.platform.getPlugin().loadData().then((data) => {
            this.data = data || {};
            this.isLoading = false;

            resolve(true);
        }).catch((error) => {
            this.isLoading = false;

            console.log("[connector] Error retrieving platform data", error);

            this.bus.trigger("error:load", ERRORS.STORAGE.LOAD.UNKNOWN);

            resolve(false);
        });
    });

    return this.loadingPromise;
};

PlatformStorage.prototype.set = function (key, data) {
    const plugin = connector.platform.getPlugin();

    if (!this.isReady) {
        this.bus.trigger("error:set", ERRORS.STORAGE.NOT_READY);
        return Promise.resolve(false);
    }

    if (data === undefined) {
        data = null;
    }

    this.data[key] = data;

    return new Promise((resolve) => {
        plugin.setData(key, data).then(() => {
            resolve(true);
        }).catch((error) => {
            console.log("[connector] Error setting data", error);

            this.bus.trigger("error:set", ERRORS.STORAGE.SET.UNKNOWN);

            resolve(false);
        });
    });
};

PlatformStorage.prototype.get = function (key) {
    if (!this.isReady) {
        this.bus.trigger("error:get", ERRORS.STORAGE.NOT_READY);
        return;
    }

    return this.data[key];
};

PlatformStorage.prototype.getKeys = function () {
    if (!this.isReady) {
        this.bus.trigger("error:getKeys", ERRORS.STORAGE.NOT_READY);
        return;
    }

    return Object.keys(this.data);
};

// await connector.storage.ready;
//
// connector.storage.set(key, {prop: "val"});
// connector.storage.get(key);
// const data = await connector.storage.load();
